"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModeratorApprovalPanelHeader = exports.ModeratorApprovalPanelBody = exports.LabelWithLinkInText = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _Switcher = _interopRequireDefault(require("../../preact-components/control/Switcher"));

var _PanelItems = require("../registration-rules/PanelItems");

var _Message = require("../ui-components/Message");

var _ExternalLink = require("../ui-components/ExternalLink");

var _PanelHeaderWithIcon = require("../ui-components/PanelHeaderWithIcon");

var ModeratorApprovalPanelBody = function ModeratorApprovalPanelBody(_ref) {
  var isModeratorApprovalEnabled = _ref.isModeratorApprovalEnabled,
      showActionButtons = _ref.showActionButtons,
      _onSave = _ref.onSave,
      _onCancel = _ref.onCancel,
      onModeratorApprovalChanged = _ref.onModeratorApprovalChanged;
  return (0, _preact.h)("div", {
    className: "panel-body-container"
  }, (0, _preact.h)(_Message.Message, {
    text: "Users with the following roles are excluded from this control: Administrator, Community Manager, Moderator, Superuser."
  }), (0, _preact.h)("div", null, (0, _preact.h)(_Switcher.default, {
    on: isModeratorApprovalEnabled,
    customClass: "panel-switch moderator-approval-panel",
    label: (0, _preact.h)(LabelWithLinkInText, null),
    onChange: function onChange() {
      return onModeratorApprovalChanged(!isModeratorApprovalEnabled);
    }
  })), (0, _preact.h)(_ExternalLink.ExternalLink, {
    label: "How to review and approve new posts",
    url: "https://community.insided.com/moderating-content-79/how-to-enable-moderator-approval-of-posts-by-new-users-469"
  }), showActionButtons && (0, _preact.h)(_PanelItems.ActionButtons, {
    onSave: function onSave() {
      return _onSave();
    },
    onCancel: function onCancel() {
      return _onCancel();
    }
  }));
};

exports.ModeratorApprovalPanelBody = ModeratorApprovalPanelBody;

var LabelWithLinkInText = function LabelWithLinkInText() {
  return (0, _preact.h)("div", null, (0, _preact.h)("div", {
    className: "panel-switch-label-text"
  }, "Enable moderator approval of new topics and replies"), (0, _preact.h)("div", {
    className: "panel-switch-info-text"
  }, "All new topics and replies from users will be sent to ", (0, _preact.h)("a", {
    className: "panel-switch-label-link",
    href: (0, _absoluteUrlRuntime.resolveUrl)("/pending/overview"),
    target: "_blank"
  }, "Pending"), ". These topics and replies will only be visible on the community after moderator approval."));
};

exports.LabelWithLinkInText = LabelWithLinkInText;

var ModeratorApprovalPanelHeader = function ModeratorApprovalPanelHeader(_ref2) {
  var statusText = _ref2.statusText;
  return (0, _preact.h)(_PanelHeaderWithIcon.PanelHeaderWithIcon, {
    customClass: "panel-header-container",
    iconCustomClass: "icon-panel-header",
    icon: "moderatorApproval",
    title: "Moderator approval of new topics and replies",
    statusText: statusText
  });
};

exports.ModeratorApprovalPanelHeader = ModeratorApprovalPanelHeader;